/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M62.5 221.7v24.4c0 37.9 30.7 68.6 68.6 68.6h737.7c37.9 0 68.6-30.7 68.6-68.6v-24.4c0-37.9-30.7-68.6-68.6-68.6H131.1c-37.9 0-68.6 30.7-68.6 68.6zm68.6 359.4h737.7c37.9 0 68.6-30.7 68.6-68.6V488c0-37.9-30.7-68.6-68.6-68.6H131.1c-37.9 0-68.6 30.7-68.6 68.6v24.4c0 38 30.7 68.7 68.6 68.7zm0 266.3h737.7c37.9 0 68.6-30.7 68.6-68.6v-24.4c0-37.9-30.7-68.6-68.6-68.6H131.1c-37.9 0-68.6 30.7-68.6 68.6v24.4c0 37.9 30.7 68.6 68.6 68.6z"/>'
  }
})
